import { Box, Button, TextField, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { Orders } from '@hellohair/types';
import { useStyles } from '../../../theme/styles.helpers';
import { RequestModalActionsStyles } from './RequestModalActions.Styles';

interface RequestModalActionsProps {
  comment: string;
  onCommentChange: (value: string) => void;
  onCommentBlur: () => void;
  onDeny: () => void;
  onAccept: () => void;
  orderState: Orders.OrderRequestState | undefined;
}

export const RequestModalActions: FC<RequestModalActionsProps> = ({
  comment,
  onCommentChange,
  onCommentBlur,
  onDeny,
  onAccept,
  orderState,
}) => {
  const [confirmAction, setConfirmAction] = useState<'accept' | 'deny' | null>(null);
  const styles = useStyles(RequestModalActionsStyles, { confirmAction, orderState });

  const isIdle = orderState === Orders.OrderRequestState.IDLE;

  const onConfirm = () => {
    if (confirmAction === 'accept') onAccept();
    else if (confirmAction === 'deny') onDeny();
  };

  return (
    <Box sx={styles.card}>
      <Typography sx={styles.cardLabel}>
        Interne Notiz <span>(optional)</span>
      </Typography>

      <TextField
        multiline
        minRows={3}
        fullWidth
        placeholder="z.B. Begründung bei Ablehnung..."
        value={comment}
        onChange={(e) => onCommentChange(e.target.value)}
        onBlur={onCommentBlur}
        variant="outlined"
        size="small"
        sx={styles.textField}
      />

      {confirmAction === null && isIdle && (
        <Box sx={styles.buttonRow}>
          <Button variant="outlined" onClick={() => setConfirmAction('deny')} sx={styles.denyButton}>
            Ablehnen
          </Button>
          <Button variant="contained" onClick={() => setConfirmAction('accept')} sx={styles.acceptButton}>
            Rezept ausstellen ✓
          </Button>
        </Box>
      )}

      {confirmAction !== null && (
        <Box>
          <Typography sx={styles.confirmText}>
            {confirmAction === 'accept' ? 'Rezept wirklich ausstellen?' : 'Anfrage wirklich ablehnen?'}
          </Typography>
          <Box sx={styles.buttonRow}>
            <Button variant="outlined" onClick={() => setConfirmAction(null)} sx={styles.cancelButton}>
              Abbrechen
            </Button>
            <Button variant="contained" onClick={onConfirm} sx={styles.confirmButton}>
              Ja, bestätigen
            </Button>
          </Box>
        </Box>
      )}

      {!isIdle && orderState && (
        <Typography sx={styles.statusText}>
          {orderState === Orders.OrderRequestState.ALLOWED ? '✓ Rezept ausgestellt' : '✗ Anfrage abgelehnt'}
        </Typography>
      )}
    </Box>
  );
};
